import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { showCompanyUsers, editCompanyUsers, createCompanyUsers } from '../../controllers/apiCompanyUsers'; // Importa el servicio
import { useNavigate, useLocation } from "react-router-dom"; // Para la redirección
import { decryptText } from '../../controllers/api'; // Importa el servicio para encriptar/desencriptar parametros
import { toast, ToastContainer } from "react-toastify"; // Importamos las funciones necesarias
import "react-toastify/dist/ReactToastify.css"; // Importar el CSS de las notificaciones
import $ from "jquery";
import { validateFormatEmail } from "../../utils/formatters";
import { Autocomplete, TextField } from "@mui/material";
import { getClients, showClient, normalizeClientsResponse } from '../../controllers/api_clients';
import { preventEnterSubmit, FORM_FOOTER_CONTAINER, FORM_BTN_CANCEL, FORM_BTN_SUBMIT } from "../../utils/formHelpers";

// (2026-08-05) Busca una empresa por id dentro de la lista ya cargada.
// COMPARACION POR STRING A PROPOSITO: el id que llega por query param
// (?empresa_id=123) es un STRING y los ids de la lista son NUMBER; un `===`
// directo nunca casaria y la precarga fallaria en silencio.
const buscarEmpresaPorId = (lista, id) => {
  if (id == null || id === '' || id === '#') return null;
  const arr = Array.isArray(lista) ? lista : [];
  return arr.find((e) => e && String(e.id) === String(id)) || null;
};

function FormCompanyUsers() {
  const navigate = useNavigate(); // Hook para redirección
  // Obtener los query parameters con `useLocation`
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const companyUserId = queryParams.get("id"); // Obtener el ID de la URL
  // (2026-05-25 v10) Precargar empresa_id desde query string para el flujo
  // "post-crear-empresa → crear usuario inicial". FormClients redirige a este
  // form pasando ?empresa_id=<id> de la empresa recién creada para que el
  // admin no tenga que volver a buscarla en el selector.
  const empresaIdPreCargada = queryParams.get("empresa_id");
  const [companyUser, setCompanyUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [errors, setErrors] = useState({}); // Estado para errores de validación
  const [clients, setClients] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [filterResultsAdmin, setFilterResultsAdmin] = useState([]);
  const authData = localStorage.getItem("authData");
  const rol = authData ? JSON.parse(authData)["rol"] : "";
  var authclientId;
  //console.log('rol: ', rol);
  if (authData) {
    authclientId = JSON.parse(authData)['empresa_id'];
  }

  // Simulando la carga de datos del companyUser por el ID
  useEffect(() => {
    const fetchCompanyUser = async () => {
      try {
        if (companyUserId != null){
          const data = await showCompanyUsers(decryptText(companyUserId));
          // (2026-05-25 v12+v13) El backend devuelve `empresa` nested
          // ({id, rif, nombre_empresa, ...}) — antes era `cliente` (renombrado
          // en v13 por consistencia semántica: es la Empresa donde trabaja
          // el usuario, no un ClienteFinal de factura). El form lee campos
          // planos `cliente_rif` y `cliente_nombre` (legacy del state local,
          // se mantienen por ahora para evitar tocar 15+ líneas del JSX).
          // El mapeo es defensivo: si el backend no devuelve `empresa`
          // (caso admin/auditor por @post_dump), los campos planos quedan
          // en '' — coincide con el comportamiento original.
          setCompanyUser({
            ...data,
            cliente_rif: data?.empresa?.rif || '',
            cliente_nombre: data?.empresa?.nombre_empresa || '',
          });
        }else{
          await setCompanyUser({
            id: "#",
            nombre: "",
            email: "",
            rol: "",
            // (2026-05-15) operador_admin solo crea usuarios para SU propia
            // empresa: el selector de cliente es admin-only, así que para
            // no-admin se asigna automáticamente su cliente del token.
            // (Antes quedaba en '#' y validate() bloqueaba con
            // "Cliente es obligatorio" sin forma de resolverlo.)
            // (2026-05-25 v10) Si vienen del flujo "crear empresa → crear
            // usuario", `empresaIdPreCargada` trae el id por query param y
            // tiene prioridad sobre el default de admin.
            empresa_id: empresaIdPreCargada
              ? empresaIdPreCargada
              : ((rol === 'admin') ? '#' : (authclientId ?? '#')),
            cliente_rif: '',
            cliente_nombre: '',
            // (2026-05-13) Campos de integrador, solo editables por admin.
            es_integrador: false,
            origen: "",
            aplicativo: "",
            version_app: "",
          })
        }
        // (2026-08-05, bug reportado por el cliente) El selector debe listar
        // TODAS las empresas asignables, INCLUIDAS las de tercero:
        //   - se elimina el filtro `es_tercero: false`. La premisa de
        //     2026-05-13 ("los terceros no tienen acceso a la plataforma")
        //     dejo de ser cierta: el acceso con usuario propio del tercero es
        //     un camino soportado, y sin listarlos es IMPOSIBLE asignar el
        //     usuario a la empresa de tercera recien creada.
        //   - se eliminan `page`/`per_page`/`request_type`: pasarlos anulaba
        //     el lote completo de api_clients.js (solo se aplica cuando el
        //     llamador NO pide paginacion) y la lista quedaba TRUNCADA a 20
        //     empresas sin ninguna señal.
        let listaEmpresas = [];
        if (rol == 'admin'){
          listaEmpresas = normalizeClientsResponse(await getClients());
          setClients(listaEmpresas);
        }
        // (2026-08-05) Precarga del flujo "crear empresa -> crear usuario".
        // El Autocomplete se pinta con value={null} e inputValue={cliente_rif},
        // asi que con solo `empresa_id` el campo aparecia VACIO aunque
        // internamente ya hubiera empresa asignada (contradiciendo al banner
        // "Empresa precargada desde el paso anterior").
        // Se resuelve DENTRO del mismo efecto y DESPUES del await de la lista
        // — no en un segundo useEffect que competiria con la carga:
        //   1) se busca en la lista ya traida (sin peticion extra);
        //   2) solo si no esta (empresa filtrada/inactiva o lista incompleta)
        //      se consulta showClient(id) como red de seguridad.
        // El id resuelto se guarda como el de la fila (NUMBER), no el string
        // del query param.
        if (companyUserId == null && empresaIdPreCargada && rol == 'admin') {
          let empresaPre = buscarEmpresaPorId(listaEmpresas, empresaIdPreCargada);
          if (!empresaPre) {
            try {
              empresaPre = await showClient(empresaIdPreCargada);
            } catch (e) {
              empresaPre = null;
            }
          }
          if (empresaPre && empresaPre.id != null) {
            setCompanyUser((prev) => ({
              ...prev,
              empresa_id: empresaPre.id,
              cliente_rif: empresaPre.rif || '',
              cliente_nombre: empresaPre.nombre_empresa || '',
            }));
          }
        }
      } catch (err) {
        console.error('err: ', err);
        setError('Error al cargar el usuario de la empresa');
      } finally {
        setLoading(false); // Indicamos que la carga ha finalizado
      }
    };
    fetchCompanyUser();
  }, [companyUserId]); // Recarga si el `companyUserId` cambia

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  const validate = () => {
    const newErrors = {};
    var errorToast = [];
    if (!companyUser.nombre){
      newErrors.nombre = "Nombre es obligatoria";
      errorToast.push("- Nombre es obligatoria");
    }
    if (!companyUser.email){
      newErrors.email = "Correo electrónico es obligatorio";
      errorToast.push("- Correo electrónico es obligatorio");
    }
    if (companyUser.email){
      if (!validateFormatEmail(companyUser.email)){
        newErrors.email = "Correo electrónico no presenta un formato válido";
        errorToast.push("- Correo electrónico no presenta un formato válido");
      }
    }
    if (!companyUser.rol || companyUser.rol == '#'){
      newErrors.rol = "Rol es obligatorio";
      errorToast.push("- Rol es obligatorio");
    }
    // (2026-05-15) operador_admin solo gestiona usuarios de SU empresa: si no
    // hay empresa_id (selector admin-only) se asume el del token.
    if (rol !== 'admin' && (companyUser.empresa_id == null || companyUser.empresa_id == '#') && authclientId != null) {
      companyUser.empresa_id = authclientId;
    }
    if ((companyUser.rol == 'operador' || companyUser.rol == 'operador_admin' || companyUser.rol == 'visor') && (companyUser.empresa_id == null || companyUser.empresa_id == '#')){//
      newErrors.empresa_id = "Empresa es obligatoria";
      errorToast.push("- Empresa es obligatoria");
    }
    // (2026-05-15) Un creador no-admin NO puede crear usuarios auditor/admin.
    if (rol !== 'admin' && (companyUser.rol == 'auditor' || companyUser.rol == 'admin')) {
      newErrors.rol = "No tiene permiso para crear usuarios con ese rol";
      errorToast.push("- No tiene permiso para crear usuarios con rol Auditor/Administrador");
    }
    // (2026-05-13) Cuando es_integrador esta activo:
    //   - aplicativo y version_app son obligatorios; 'origen' opcional.
    //   - el rol del usuario DEBE ser 'operador_admin' (no negociable).
    if (companyUser.es_integrador) {
      if (companyUser.rol !== 'operador_admin') {
        newErrors.rol = "Un usuario Integrador debe tener rol 'Operador Admin'";
        errorToast.push("- Un usuario Integrador debe tener rol 'Operador Admin'");
      }
      if (!companyUser.aplicativo || !String(companyUser.aplicativo).trim()) {
        newErrors.aplicativo = "Aplicativo es obligatorio cuando el usuario es Integrador";
        errorToast.push("- Aplicativo es obligatorio cuando el usuario es Integrador");
      }
      if (!companyUser.version_app || !String(companyUser.version_app).trim()) {
        newErrors.version_app = "Versión App es obligatoria cuando el usuario es Integrador";
        errorToast.push("- Versión App es obligatoria cuando el usuario es Integrador");
      }
    }
    setErrors(newErrors);
    if (errorToast.length > 0){
      toast.error(<div>
        {errorToast.map(item => (
            <span className="text-start">{item}<br/></span>
          ))}
      </div>)
      setButtonDisabled(false);
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Aquí enviarías los datos de nuevo al backend para actualizar al companyUser
    if (!validate()) return;
    setButtonDisabled(true); // Iniciar carga (deshabilitar botón)
    //console.log("Company User:", companyUser);
    try {
      var data;
      var message = '';
      if (companyUser.id == '#'){
        delete companyUser.id;
        //console.log("Company User(F): ", companyUser);
        if (rol == 'admin'){
          var empresa_id = companyUser.empresa_id;
          //console.log("Company empresa_id(F): ", empresa_id);
          if (companyUser.rol == 'admin' || companyUser.rol == 'auditor'){
            delete companyUser.empresa_id;
            delete companyUser.cliente_rif;
            delete companyUser.cliente_nombre;
            empresa_id = null;
          }
          //console.log("Company empresa_id(F): ", empresa_id);
          data = await createCompanyUsers(companyUser, empresa_id);
        }else{
          data = await createCompanyUsers(companyUser);
        }
        message = '!Creación de usuario de la empresa realizada correctamente!';
      }else{
        data = await editCompanyUsers(decryptText(companyUserId), companyUser); 
        message = '!Actualización de usuario de la empresa realizada correctamente!';
      }
      //setCompanyUser(data);
      //console.log('data: ', data);
      if (data.status != 201 && data.status != 200) {
        if (data.data?.error) {
          toast.error(data.data.error);
        } else {
          toast.error(`${data.status} - ${data.message}`);
        }
        setButtonDisabled(false);
        return;
      }else{
        // (2026-05-25 v14) Fallback al mensaje local si el backend no envía
        // un `mensaje` explícito. Antes: cuando el backend devolvía solo el
        // usuario serializado (sin `mensaje`), el toast mostraba "undefined".
        // El mensaje del backend tiene prioridad (ej. "Sin cambios." cuando
        // no se modificó nada — fix complementario en user_routes.py v14).
        const toastMsg = data.data?.mensaje || message;
        toast.success(toastMsg, {
          onClose: () => {
            // Espera a que la notificación se cierre para redirigir
            setTimeout(() => {
              navigate("/company-users");  // Redirige a la lista de usuarios de la empresa
            }, 2000); // El tiempo debe ser el mismo o ligeramente mayor que la duración de la notificación
          },
        });
      }
    } catch (err) {
      setError('Error al cargar el usuario de la empresa');
      // Mostrar una notificación de error
      toast.error("Error al actualizar el usuario de la empresa");  // Notificación de error
    } finally {
      setLoading(false); // Indicamos que la carga ha finalizado
    }
  };

  const redirectToList = () => {
    navigate(`/company-users`);
  };

// (2026-08-03, ronda 2 / T1) Máscara del R.I.F. — clase `[VJEPGC]` portada
// EXACTAMENTE de components/Clients/FormClients.js:716. La 'C' (Comunal) entró
// por decisión del usuario y `utils.validar_rif` la admite
// (`^[VEJGPC]-\d{8}-\d$`, utils.py:351). Sin ella la máscara borra la letra en
// la primera pulsación y el RIF comunal es INTECLEABLE en este formulario.
const handleSearchRif = (value, type) => {
  //console.log('handleSearchRif-value: ', value);
  //console.log('handleSearchRif-type: ', type);
  value = value.toUpperCase();

  // Elimina caracteres no válidos (solo letras, números y guiones)
  value = value.replace(/[^A-Z0-9-]/g, "");

  // Forzar el patrón paso a paso
  if (value.length === 1) {
    // Primera posición → solo letras válidas
    if (!/[VJEPGC123456789]/.test(value)) value = "";
  } else if (value.length === 2) {
      // Solo agregar guion si comienza con letra válida
      if (/[VJEPGC]/.test(value[0]) && !value.includes("-")) {
        value = value[0] + "-" + value[1];
      }
    } else if (value.length > 2) {
    // Nuevo: permitir solo números (hasta 8)
    const matchSoloNumeros = value.match(/^\d{0,8}$/);

    if (matchSoloNumeros) {
      value = matchSoloNumeros[0];
    } else {
      // Caso RIF tradicional
      const match = value.match(/^([VJEPGC])-(\d{0,8})-?(\d{0,1})?$/);

      if (match) {
        const [, letra, numeros, verificador] = match;
        value = `${letra}-${numeros}${numeros.length === 8 ? "-" : ""}${verificador || ""}`;
      } else {
        value = companyUser.cliente_rif;
      }
    }
  }

  // Actualiza el campo
  setCompanyUser((prev) => ({ ...prev, cliente_rif: value }));

  if (value.length < 2) {
    if (type == 'admin'){
      setFilterResultsAdmin([]);
    }else{
      setFilterResults([]);
    }
    return;
  }
  var results;
  if (type == 'admin'){
    //console.log('clients: ', clients);
    results = clients.filter((c) =>
      c.rif.toUpperCase().includes(value) ||
      c.nombre_empresa.toUpperCase().includes(value)
    );
  }else{
    //console.log('endClients: ', endClients);
    results = endClients.filter((c) =>
      c.rif.toUpperCase().includes(value) ||
      c.nombre.toUpperCase().includes(value)
    );
  }
  //console.log('handleSearchRif-results.length: ', results.length);
  if (results.length == 0){
    $('#div_none_endclients').attr('style', "width: 600px;");
    $('.form-client-complement').addClass('mt-10');
    setCompanyUser((prev) => ({
    ...prev,
      cliente_id: '#',
      //cliente_rif: '',
      cliente_nombre: '',
      // (2026-08-05) Si lo tecleado no casa con NINGUNA empresa, tampoco puede
      // quedar seleccionada la anterior (la precargada del query param o la de
      // una seleccion previa): se limpia empresa_id para que validate() exija
      // volver a elegir en lugar de guardar en silencio contra otra empresa.
      empresa_id: '#',
    }));

  }else{
    $('#div_none_endclients').removeAttr('style');
    $('.form-client-complement').removeClass('mt-10');
  }
  setFilterResultsAdmin(results);
  setShowResults(true);
};

const selectClient = async (client, type) => {
  setCompanyUser((prev) => ({
    ...prev,
    empresa_id: client.id || '#',
    cliente_rif: client.rif || '',
    cliente_nombre: client.nombre_empresa || '',
  }));
  setFilterResultsAdmin([]);
  setShowResults(false);
};

const reduceRif = (rif, type) => {
  setCompanyUser((prev) => ({
    ...prev,
    cliente_rif: rif || '',
  }));
};

  return (
    <div className="mx-auto w-full">
      <ToastContainer />
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12">
          <div className="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg border-0">
            {/* Header */}
            <div className="rounded-t bg-white mb-0 px-6 py-6">
              <div className="text-center flex justify-between">
                <h6 className="text-blueGray-700 text-xl font-bold">{companyUser.id == '#'? "Crear" : "Actualizar"} Usuario de la Empresa</h6>
              </div>
            </div>

            {/* (2026-05-25 v10) Banner WARNING — usuario huérfano:
                 cuando se EDITA un usuario cuyo rol requiere empresa_id
                 pero su empresa_id es NULL (huérfano por bug previo o
                 reasignación pendiente). Indica al admin que debe
                 vincularlo antes de que el usuario pueda operar. */}
            {companyUser.id != '#'
              && (companyUser.rol === 'operador' || companyUser.rol === 'operador_admin' || companyUser.rol === 'visor')
              && (companyUser.empresa_id == null || companyUser.empresa_id === '' || companyUser.empresa_id === '#') && (
              <div className="mx-6 mb-4 p-4 rounded-lg border-l-4 border-yellow-400 bg-yellow-50 flex items-start gap-3">
                <span className="text-2xl leading-none">⚠️</span>
                <div className="text-sm">
                  <div className="font-semibold text-yellow-800">Este usuario no está vinculado a ninguna empresa.</div>
                  <div className="text-yellow-700 mt-1">
                    El rol <code className="bg-yellow-100 px-1 rounded text-xs">{companyUser.rol}</code> requiere una empresa
                    asociada para poder operar. {rol === 'admin'
                      ? 'Asigne una en el selector "Empresa Afiliada" y guarde los cambios.'
                      : 'Contacte al administrador del sistema para que asigne la empresa correspondiente.'}
                  </div>
                </div>
              </div>
            )}

            {/* (2026-05-25 v10) Banner INFO — empresa precargada desde el
                 flujo "crear empresa → crear usuario inicial". */}
            {companyUser.id == '#' && empresaIdPreCargada && rol === 'admin' && (
              <div className="mx-6 mb-4 p-4 rounded-lg border-l-4 border-blue-400 bg-blue-50 flex items-start gap-3">
                <span className="text-2xl leading-none">🔗</span>
                <div className="text-sm">
                  <div className="font-semibold text-blue-800">Empresa precargada desde el paso anterior.</div>
                  <div className="text-blue-700 mt-1">
                    Estás creando el usuario inicial para la empresa recién registrada.
                    Si deseas crearlo para otra empresa, cambia el selector "Empresa Afiliada".
                  </div>
                </div>
              </div>
            )}

            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
              <h6 className="text-blueGray-400 text-sm mt-3 my-6 font-bold uppercase">Informacion del usuario de la empresa</h6>
              <form onSubmit={handleSubmit} onKeyDown={preventEnterSubmit}>
                <hr className="my-6 border-b-1 border-blueGray-300"/>
                <div className="flex flex-wrap">
                  {/* (2026-05-13) El selector de empresa afiliada solo aplica
                      cuando el target user es de empresa (no admin/auditor).
                      Los usuarios internos se crean sin empresa_id. */}
                  {(rol == 'admin') && companyUser.rol !== 'admin' && companyUser.rol !== 'auditor' && (
                    <div className="relative lg:w-3/12 mb-3 mx-3">
                        <label className="block text-blueGray-600 text-xs font-bold mb-2">Empresa Afiliada (RIF)</label>
                        <input
                          type="text"
                          className="hidden border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          value={companyUser.empresa_id}
                          placeholder="J-12345678-0"
                          onChange={(e) => setCompanyUser({ ...companyUser, empresa_id: e.target.value })}
                        />
                        <div className="relative">
                          <Autocomplete
                              freeSolo
                              options={
                                showResults && companyUser.cliente_rif !== ''
                                  ? filterResultsAdmin ?? []
                                  : clients ?? []}
                              getOptionLabel={(opt) =>
                                opt?.rif ? `${opt.rif} — ${opt.nombre_empresa}` : ""
                              }
                              filterOptions={(options) => options} // usamos tu propio filtro manual
                              value={null}
                              disabled={(companyUser.rol == 'admin' || companyUser.rol == 'auditor') ? true : false}
                              inputValue={companyUser.cliente_rif || ""}
                              onInputChange={(e) => {
                                let value = e.target.value?.toString().toUpperCase();
                                if (value == undefined){
                                  value = '';
                                }
                                // Elimina caracteres no válidos (solo letras, números y guiones)
                                value = value.replace(/[^A-Z0-9-]/g, "");

                                // Forzar el patrón paso a paso
                                if (value.length === 1) {
                                  // Primera posición → solo letras válidas
                                  if (!/[VJEPGC123456789]/.test(value)) value = "";
                                } else if (value.length === 2) {
                                    // Solo agregar guion si comienza con letra válida
                                    if (/[VJEPGC]/.test(value[0]) && /[1234567890]/.test(value[1]) && !value.includes("-")) {
                                      if (/[VJEPGC1234567890-]/.test(value[1])){
                                        value = value[0] + "-" + value[1];
                                      }else{
                                        value = value[0];
                                      }
                                    }else if (!/[1234567890]/.test(value)) {
                                      value = value[0];
                                    }
                                  } else if (value.length > 2) {
                                  // Nuevo: permitir solo números (hasta 8)
                                  const matchSoloNumeros = value.match(/^\d{0,8}$/);

                                  if (matchSoloNumeros) {
                                    value = matchSoloNumeros[0];
                                  } else {
                                    // Caso RIF tradicional
                                    const match = value.match(/^([VJEPGC])-(\d{0,8})-?(\d{0,1})?$/);
                                    if (match) {
                                      const [, letra, numeros, verificador] = match;
                                      value = `${letra}-${numeros}${numeros.length === 8 ? "-" : ""}${verificador || ""}`;
                                    } else {
                                      value = companyUser.cliente_rif;
                                    }
                                  }
                                }

                                handleSearchRif(value, 'admin')
                              }}
                              onChange={(event, newValue) => {
                                if (newValue) selectClient(newValue, 'admin');
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="V-12345678-0"
                                  placeholder="V-12345678-0"
                                  variant="outlined"
                                  size="small"
                                  onKeyDown={(e) => {
                                    // Si el usuario presiona Backspace
                                    if (e.key === "Backspace") {
                                      if (companyUser.cliente_rif.substr(companyUser.cliente_rif.length - 1, companyUser.cliente_rif.length) == '-'){
                                        reduceRif(companyUser.cliente_rif.substr(0, companyUser.cliente_rif.length - 1), 'admin');
                                      }
                                    }
                                    // ENTER para seleccionar primer elemento si no se ha elegido uno
                                    if (e.key === "Enter") {
                                      if (filterResultsAdmin.length > 0) {
                                        e.preventDefault();
                                        selectClient(filterResultsAdmin[0], 'admin');
                                      }
                                    }
                                  }}
                                />
                              )}
                            />
                        </div>
                        {errors.empresa_id && <p className="text-red-500 text-xs mt-1">{errors.empresa_id}</p>}
                    </div>
                  )}
                  {(rol == 'admin') && companyUser.rol !== 'admin' && companyUser.rol !== 'auditor' && (
                    <div className="w-full lg:w-8/12 px-1">
                      <div className="relative w-full mb-3">
                        <label className="block text-blueGray-600 text-xs font-bold mb-2">Razon Social</label>
                        <input
                          type="text"
                          className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                          value={companyUser.cliente_nombre} readonly="readonly"
                          placeholder="Nombre de la empresa afiliada"
                          onChange={(e) => setCompanyUser({ ...companyUser, cliente_nombre: e.target.value.toString().toUpperCase() })}
                        />
                      </div>
                    </div>
                  )}
                  <div className="w-full lg:w-10/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Nombre</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={companyUser.nombre}
                        placeholder="Nombre del usuario"
                        onChange={(e) => setCompanyUser({ ...companyUser, nombre: e.target.value.toUpperCase() })}
                      />
                      {errors.nombre && <p className="text-red-500 text-xs mt-1">{errors.nombre}</p>}
                      </div>
                  </div>
                  <div className="w-full lg:w-5/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Correo Electronico</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={companyUser.email}
                        placeholder="correo@correo.com"
                        onChange={(e) => setCompanyUser({ ...companyUser, email: e.target.value.toUpperCase() })}
                      />
                      {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Rol</label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed"
                        value={companyUser.rol}
                        disabled={!!companyUser.es_integrador}
                        onChange={(e) => {
                          const nuevoRol = e.target.value;
                          // (2026-05-15) Solo un creador ADMIN crea usuarios
                          // internos (admin/auditor) sin empresa_id. Para un
                          // operador_admin el empresa_id SIEMPRE debe ser el
                          // suyo (del token): antes este onChange lo ponía en
                          // null y validate() bloqueaba "Cliente es obligatorio".
                          if (rol === 'admin' && (nuevoRol === 'admin' || nuevoRol === 'auditor')) {
                            setCompanyUser({
                              ...companyUser,
                              rol: nuevoRol,
                              empresa_id: null,
                              cliente_rif: '',
                              cliente_nombre: ''
                            });
                          } else {
                            setCompanyUser({
                              ...companyUser,
                              rol: nuevoRol,
                              // No-admin: re-asegurar el cliente del token.
                              ...(rol !== 'admin' ? { empresa_id: (authclientId ?? '#') } : {})
                            });
                          }
                        }}>
                        <option value="#">Seleccione...</option>
                        <option value="operador">Operador</option>
                        <option value="operador_admin">Operador Admin</option>
                        <option value="visor">Visor</option>
                        {/* (2026-05-13) Rol Administrador habilitado solo
                            cuando el caller es admin (no auditor). Los admin
                            se crean sin empresa_id (usuario interno). */}
                        {rol === 'admin' && (
                          <option value="admin">Administrador</option>
                        )}
                        {/* (2026-05-15) Auditor SOLO lo puede crear un admin.
                            Un operador_admin no debe poder crear auditores. */}
                        {rol === 'admin' && (
                          <option value="auditor">Auditor</option>
                        )}
                      </select>
                      {companyUser.es_integrador && (
                        <p className="text-xs text-blueGray-500 mt-1">
                          <i className="fas fa-lock mr-1" />
                          Forzado a "Operador Admin" porque el usuario es Integrador.
                        </p>
                      )}
                      {errors.rol && <p className="text-red-500 text-xs mt-1">{errors.rol}</p>}
                    </div>
                  </div>

                </div>

                {/* (2026-05-13) Bloque de Integrador. Visible solo para admin
                    y auditor. El checkbox 'Es Integrador' siempre se ve; los
                    3 campos dependientes (aplicativo, version_app, origen)
                    aparecen UNICAMENTE cuando es_integrador esta activo.
                    El auditor ve todo en modo lectura. */}
                {(rol === 'admin' || rol === 'auditor') && (
                  <>
                    <h6 className="text-blueGray-400 text-sm mt-3 mb-3 font-bold uppercase">
                      Integración (solo administradores)
                    </h6>
                    <div className="flex flex-wrap">
                      <div className="w-full lg:w-3/12 px-4">
                        <div className="relative w-full mb-3 flex items-center gap-2 pt-6">
                          <input
                            id="es_integrador"
                            type="checkbox"
                            className="h-4 w-4"
                            checked={!!companyUser.es_integrador}
                            disabled={rol !== 'admin'}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setCompanyUser({
                                ...companyUser,
                                es_integrador: checked,
                                // Al activar es_integrador, el rol queda forzado
                                // a 'operador_admin' (regla de negocio fija).
                                // Al desactivar, limpiar los 3 campos dependientes
                                // para evitar enviar datos huerfanos al backend.
                                ...(checked
                                  ? { rol: 'operador_admin' }
                                  : { aplicativo: "", version_app: "", origen: "" }),
                              });
                            }}
                          />
                          <label htmlFor="es_integrador" className="text-blueGray-600 text-xs font-bold">
                            Es Integrador
                          </label>
                        </div>
                      </div>
                      {companyUser.es_integrador && (
                        <>
                          <div className="w-full lg:w-3/12 px-4">
                            <div className="relative w-full mb-3">
                              <label className="block text-blueGray-600 text-xs font-bold mb-2">
                                Aplicativo <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                value={companyUser.aplicativo || ""}
                                placeholder="EJ. SAP, SAGE, ERP-X"
                                disabled={rol !== 'admin'}
                                onChange={(e) => setCompanyUser({ ...companyUser, aplicativo: e.target.value.toUpperCase() })}
                              />
                              {errors.aplicativo && <p className="text-red-500 text-xs mt-1">{errors.aplicativo}</p>}
                            </div>
                          </div>
                          <div className="w-full lg:w-3/12 px-4">
                            <div className="relative w-full mb-3">
                              <label className="block text-blueGray-600 text-xs font-bold mb-2">
                                Versión App <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                value={companyUser.version_app || ""}
                                placeholder="EJ. 2.4.1"
                                disabled={rol !== 'admin'}
                                onChange={(e) => setCompanyUser({ ...companyUser, version_app: e.target.value.toUpperCase() })}
                              />
                              {errors.version_app && <p className="text-red-500 text-xs mt-1">{errors.version_app}</p>}
                            </div>
                          </div>
                          <div className="w-full px-4">
                            <div className="relative w-full mb-3">
                              <label className="block text-blueGray-600 text-xs font-bold mb-2">
                                Origen permitido (IPs / CIDR / hostnames, separados por coma) — opcional
                              </label>
                              <textarea
                                rows={2}
                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                value={companyUser.origen || ""}
                                placeholder="190.142.10.5, 10.0.0.0/24, INTEGRADOR.EMPRESA.COM"
                                disabled={rol !== 'admin'}
                                onChange={(e) => setCompanyUser({ ...companyUser, origen: e.target.value.toUpperCase() })}
                              />
                              <p className="text-xs text-blueGray-400 mt-1">
                                Vacío = sin restricción de IP. Solo aplica si "Es Integrador" está activo.
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}

                <div className={FORM_FOOTER_CONTAINER}>
                  <button
                    type="button"
                    className={FORM_BTN_CANCEL}
                    disabled={buttonDisabled}
                    onClick={() => redirectToList()}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className={FORM_BTN_SUBMIT}
                    disabled={buttonDisabled}
                  >
                    {buttonDisabled
                      ? (companyUser.id == '#' ? "Guardando..." : "Actualizando...")
                      : (companyUser.id == '#' ? "Guardar" : "Actualizar")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormCompanyUsers;